import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setSearchResults, clearSearchResults } from './actions';

const searchResultSelector = (state) => state.multiMemberSearch;

export const useSearchResults = {
  state: () => {
    const searchResults = useSelect(searchResultSelector);
    return { searchResults };
  },
  actions: () => {
    return {
      setSearchResults: useAction(setSearchResults),
      clearSearchResults: useAction(clearSearchResults),
    };
  },
};
